import { render, staticRenderFns } from "./mixIssue.vue?vue&type=template&id=0da5a862&scoped=true"
import script from "./mixIssue.vue?vue&type=script&lang=js"
export * from "./mixIssue.vue?vue&type=script&lang=js"
import style0 from "./mixIssue.vue?vue&type=style&index=0&id=0da5a862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5a862",
  null
  
)

export default component.exports